import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export type BrandingEditSession = {
  token: string;
  expiresIn: string;
  locationId: string;
  studioId: string;
};

export async function createBrandingEditSession(): Promise<BrandingEditSession> {
  const response = await baseAPI.post<BrandingEditSession>(
    '/studios/branding/edit-session',
  );
  return response.data;
}

export function useCreateBrandingEditSession() {
  return useMutation({
    mutationFn: createBrandingEditSession,
  });
}
